import Alert from "@mui/material/Alert";
import { Snackbar } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import "./popMessage.css";
const PopupMessage = (props: any) => {
  const showPopup = props.showPopup;
  const setShowPopup = props.setShowPopup;
  const popupMessage = props.popupMessage;
  const popupSeverity = props.popupSeverity;

  return (
    <Snackbar
      open={showPopup}
      autoHideDuration={5000}
      onClose={() => {
        setShowPopup(false);
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      {popupSeverity === "success" ? (
        <Alert
          className="popupMessageSuccessClass"
          icon={
            <CheckOutlinedIcon
              sx={{
                width: "22px",
                height: "22px",
                color: "white",
                backgroundColor: "#00A878",
                borderRadius: "50%",
              }}
            />
          }
          variant="filled"
          severity={popupSeverity}
        >
          <div className="popupMessageSuccessText">{popupMessage}</div>
        </Alert>
      ) : (
        <Alert variant="filled" sx={{ width: "80%" }} severity={popupSeverity}>
          {popupMessage}
        </Alert>
      )}
    </Snackbar>
  );
};
export default PopupMessage;
